
// Custom Form Function
$(function() {
	optionsSelector._init();


    // Seal Sunglasses Validation 
    setTimeout(function() {
      $('.sls-option-container').on('click', function() {
        setTimeout(function() {
          if($('input[name="selling_plan"]').val() != '') {
            $('.sunglasses-promo-thumbnail-wrapper').hide();
          }
          else {
            $('.sunglasses-promo-thumbnail-wrapper').show();
          }
        }, 500)
      })
    }, 2500)
});



//Options Selector
var optionsSelector = {
  productId: '',
  productJson: '',
  productSingleObject: {},
  formData: {},
  sameForBothEyes: false,

  _init: function() {
    this.productId = $('.main-product-details-section').attr('data-product-id');
  	this.productJson = $('#ProductJson-' + this.productId);
    this.productSingleObject = JSON.parse($('#ProductJson-' + this.productId).html());
    
    this._bindEvents();
  },
  
  _bindEvents() {
    
    //Same for both eyes
    $('#same_for_both_eyes_checkbox').on('click', function() {
        optionsSelector._sameForBothEyes();
    });
    
    //Trigger right Color select if sameForBothEyes is true
    $('[data-prescription="Color"]').on('change', function() {
      if(optionsSelector.sameForBothEyes) {
        $('#option_right').find('[data-prescription="Color"]').val($(this).val());
      }
    })
    
    //Precription confirmation
    $('#prescription_confirmation_checkbox').on('click', function() {
      optionsSelector._prescriptionConfirmation();
    });
    
    //Form Submit
      $('#productFormCustom').on('submit', function(e){
        e.preventDefault();
		optionsSelector._onFormSubmit();
      });
    
    //Quantity Plus Minus
    this._quantityPlusMinusBtn($('.eye-options__qty-input').find('.eye-options__qty-input-plus'), $('.eye-options__qty-input').find('.eye-options__qty-input-minus'));
    
    $('.eye-options__qty-input input').on("change", debounce(function() {
      optionsSelector._updateQuantityPrice();
    }, 150))
    
  },
  
  _getCurrentOptions: function(option) {
    var result = [];

    $.each($(option), function(index, option) {
        result.push({
          value: option.value,
          index: $(option).attr('data-index')
        });
    });
	
    return result;
  },
  
  _getVariantFromOptions: function(option) {
    var selectedValues = this._getCurrentOptions(option);
    var variants = optionsSelector.productSingleObject.variants;
	
    var found = variants.find(function(variant) {
      return selectedValues.every(function(values) {
        return variant[values.index] === values.value;
      });
    });
    
    return found;
  },
  
  _onFormSubmit: function() {
      let items = [];
      let uniqueId = 'id_'+ Date.now();
      let prescriptionError = 0;
      optionsSelector.formData.items = [];

      optionsSelector._addToCartBtnLoader(true)

      // if($('.prescription-properties-file')[0].files.length === 0) {
      //     $('.prescription-upload-error-msg').show();
      //     $('.prescription-upload-error-msg').animate({
      //       marginLeft: '2.5rem'
      //     }, 150, function() {
      //       $('.prescription-upload-error-msg').animate({
      //         marginLeft: 0
      //       }, 150);
      //     })
      //     optionsSelector._addToCartBtnLoader(false)
      //     return false;
      // }

      //SUNGLASS PROMO VALIDATION
      if($('.sunglass-properties-select').length > 0 && $('.sunglass-properties-select').val() == '') {
            $('.sunglass-select-error-msg').show();
            $('.sunglass-select-error-msg').animate({
              marginLeft: '2.5rem'
            }, 150, function() {
              $('.sunglass-select-error-msg').animate({
                marginLeft: 0
              }, 150);
            })
            optionsSelector._addToCartBtnLoader(false)
            return false;
        }
      //SUNGLASS PROMO UPDATE VALIDATION END

      $.each($('.eye-options'), function(index, option) {
        let currentEyeOption = $(option).attr('id');
        if(optionsSelector.sameForBothEyes) {
          currentEyeOption = $($('.eye-options')[0]).attr('id');
        }
        
        let currentContainerId = '#' + currentEyeOption;
        let quantitySelector = $('#quantity_' + currentEyeOption);
        let currentVariant = '#' + $(option).attr('id') +' .single-option-selector'
        
        if(quantitySelector.val() > 0) {
          let variant = optionsSelector._getVariantFromOptions(currentVariant);
          let item = {};
          let prescriptionProperties = {};

          $.each($(currentContainerId + ' .prescription-properties-select'), function(i, r){
            let prescription = $(r).attr('data-prescription');
            
            if($(r).val() == '') {
              $(r).parent().addClass('error');
              prescriptionError += 1;
            }
            else {
              $(r).parent().removeClass('error');
            }
            
            prescriptionProperties[prescription] = $(r).val();
          });

          //Prescription File
          prescriptionProperties['Prescription'] = $('.prescription-properties-file')[0].files[0];
          
          //SUNGLASS PROPERTY
          if($('.sunglass-properties-select').length > 0) {
            prescriptionProperties['Sunglasses'] = $('#selectSunglass').val();
            prescriptionProperties['sunglasses_image'] = $('#selectSunglassImg').val();
          }

          prescriptionProperties['item_number'] = $('#productItemNumber').val();
          prescriptionProperties['properties_id'] = uniqueId;

          if(prescriptionError < 1) {
            item.id = variant.id;
            item.quantity = quantitySelector.val();
            item.properties = prescriptionProperties;
  
            optionsSelector.formData.items[index] = item;
          }

        }
    });

    if(prescriptionError < 1) {
      $('.prescription-error-message').hide();
      optionsSelector._addToCart();
    }
    else {
      optionsSelector._addToCartBtnLoader(false);
      $('.prescription-error-message').show();
      $('body, html').stop().animate({
        scrollTop: $('.eye-options-wrapper').offset().top - $('.header').outerHeight()
      })
    }
  },
  
  _addToCart: function() {
    
    const formData = new FormData();
    
    $.each(optionsSelector.formData.items, function(index, item) {
      if(item != undefined) {
        formData.append('items['+index+'][id]', optionsSelector.formData.items[index].id);
        formData.append('items['+index+'][quantity]', optionsSelector.formData.items[index].quantity);
        formData.append('items['+index+'][properties][Eye]', optionsSelector.formData.items[index].properties['Eye']);
        formData.append('items['+index+'][properties][Power]', optionsSelector.formData.items[index].properties['Power']);
        formData.append('items['+index+'][properties][Base Curve]', optionsSelector.formData.items[index].properties['Base Curve']);
        formData.append('items['+index+'][properties][Diameter]', optionsSelector.formData.items[index].properties['Diameter']);
  
        if(optionsSelector.formData.items[index].properties['Add Power'] != undefined && optionsSelector.formData.items[index].properties['Add Power'] != '') {
          formData.append('items['+index+'][properties][Add Power]', optionsSelector.formData.items[index].properties['Add Power']);
        }
  
        if($('.prescription-properties-file')[0].files.length > 0) {
          formData.append('items['+index+'][properties][Prescription]', optionsSelector.formData.items[index].properties['Prescription']);
        }
  
        if($('#productItemNumber').val() != '') {
          formData.append('items['+index+'][properties][item_number]', optionsSelector.formData.items[index].properties['item_number']);
        }
  
        //ADD SUNGLASS TO PROPERTIES
        if($('.sunglass-properties-select').length > 0 && $('.sunglass-properties-select').val() != '') {
          formData.append('items['+index+'][properties][Sunglasses]', optionsSelector.formData.items[index].properties['Sunglasses']);
          formData.append('items['+index+'][properties][sunglasses_image]', optionsSelector.formData.items[index].properties['sunglasses_image']);
        }
        
        formData.append('items['+index+'][properties][properties_id]', optionsSelector.formData.items[index].properties['properties_id']);
  
        //Subscription Plan
        if($('input[name="selling_plan"]').length > 0 && $('input[name="selling_plan"]').val() != '') {
          formData.append('items['+index+'][selling_plan]', $('input[name="selling_plan"]').val());
        }
      }
    })

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData
    })
    .then(response => {
      return response.json();
    })
    .then((json) => {
      	optionsSelector._onAddToCartSuccess();
        optionsSelector._addToCartBtnLoader(false);
        // $('.prescription-upload-error-msg').hide();

        //SUNGLASS ERROR MESSAGE
        $('.sunglass-select-error-msg').hide();

      console.log(json);
      
        if(json.message == "Cart Error") {
          $('.product-form__error-messages p').html(json.description);
        }
    })
    .catch((error) => {
      console.error('Error:', error);
      
        optionsSelector._addToCartBtnLoader(false)
    });
  },
  
  _onAddToCartSuccess: function() {
  	fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
      	cartSort._init(cart);
        sidebarDrawer._open('.sidebar.cart');
      })
      .catch(function(error) {
        // eslint-disable-next-line no-console
        console.log(error);
      });
  },
  
  _sameForBothEyes: function() {
      if ($('#same_for_both_eyes_checkbox').is(":checked")) {
        this.sameForBothEyes = true;
        $('.eye-options-wrapper').addClass('same-for-both-eyes');
        $('#option_left .eye-options__side-title h4').html('Left & Right');

        //SUNGLASS PROMO QTY VALIDATION
          if($('.sunglass-properties-select').length > 0) {
            $('#quantity_option_left').val(1);
            $('#quantity_option_left').change();
          }
      } else {
        this.sameForBothEyes = false;
        $('.eye-options-wrapper').removeClass('same-for-both-eyes');
        $('#option_left .eye-options__side-title h4').html('Left');

        //SUNGLASS PROMO QTY VALIDATION
        if($('.sunglass-properties-select').length > 0) {
          $('#quantity_option_right').val(1);
          $('#quantity_option_right').change();
        }
      }
    	
      this._updateQuantityPrice();
  },
  
  _prescriptionConfirmation: function() {
    
    if ($('#prescription_confirmation_checkbox').is(":checked")) {
      $('.product-form__cart-submit').removeAttr('disabled');
    } else {
      $('.product-form__cart-submit').attr('disabled', 'disabled');
    }
  },
  
  _addToCartBtnLoader: function(bool) {
  	if(bool) {
      	$('#productFormCustom').find('.product-form__cart-submit span').attr('disabled');
        $('#productFormCustom').find('.product-form__cart-submit span').css('visibility', 'hidden');
        $('#productFormCustom').find('.product-form__cart-submit .loading-overlay__spinner').removeClass('hidden');
	}
    else {
      	$('#productFormCustom').find('.product-form__cart-submit span').removeAttr('disabled');
        $('#productFormCustom').find('.product-form__cart-submit span:first-child').css('visibility', 'visible')
        $('#productFormCustom').find('.product-form__cart-submit .loading-overlay__spinner').addClass('hidden');
    }
  },
    
  _quantityPlusMinusBtn: function(plus, minus) {

    //SUNGLASS PROMO QTY VALIDATION
    if($('.sunglass-properties-select').length > 0) {
      
      minus.click(function () {
        var $input = $(this).parent().find('input');
        var count = parseInt($input.val()) - 1;
        count = count < 0 ? 0 : count;
        
        //if greater than zero, minus one and add one to the other
        let minAllowedBoxes = 0
        if(optionsSelector.sameForBothEyes) {
          minAllowedBoxes = 1
        }
        console.log(parseInt($input.val()), minAllowedBoxes)
        if(parseInt($input.val()) > minAllowedBoxes) {
          let siblingQtyInput = $(this).parents('.eye-options').siblings().find('.eye-options__qty-input input')
          siblingQtyInput.val(parseInt(siblingQtyInput.val()) + 1)
          siblingQtyInput.change();

          $input.val(count);
          $input.change();
        }
        
        return false;
      });
      plus.click(function () {
        var $input = $(this).parent().find('input');

        //if less than 2, add 1 and minus 1 from the other one
        let maxAllowedBoxes = 2
        if(optionsSelector.sameForBothEyes) {
          maxAllowedBoxes = 1
        }
        
        if(parseInt($input.val()) < maxAllowedBoxes) {
          let siblingQtyInput = $(this).parents('.eye-options').siblings().find('.eye-options__qty-input input')
          siblingQtyInput.val(parseInt(siblingQtyInput.val()) - 1)
          siblingQtyInput.change();

          $input.val(parseInt($input.val()) + 1);
          $input.change();
        }
        
        return false;
      });
      
    }
    else {
      
      minus.click(function () {
        var $input = $(this).parent().find('input');
        var count = parseInt($input.val()) - 1;
        count = count < 0 ? 0 : count;
        $input.val(count);
        $input.change();
        return false;
      });
      plus.click(function () {
        var $input = $(this).parent().find('input');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
      });
    
    }
  },
  
  _updateQuantityPrice: function() {
    let totalQty = 0;
    
    if(this.sameForBothEyes) {
      	totalQty = parseInt($('#option_left .eye-options__qty-input input').val())
    	totalQty = totalQty*2;
    }
    else {
      $.each($('.eye-options__qty-input input'), function(i, d){
        totalQty += parseInt($(d).val());
      });
    }
    
    if(optionsSelector.productSingleObject.compare_at_price != null) {
      $('#product_form_compare-at-price').html('$'+((optionsSelector.productSingleObject.compare_at_price*totalQty)/100).toFixed(2))
    }
    
    $('#product_form_total').html('$'+((optionsSelector.productSingleObject.price*totalQty)/100).toFixed(2))
    $('.product-form__total-qty-text').html(totalQty + ' Boxes');
  },
  
  

}

